<button mat-icon-button class="dismissButton" (click)="isDismissed = true" *ngIf="allowDismiss">
    <mat-icon>close</mat-icon>
</button>

<ng-content></ng-content>